// extracted by mini-css-extract-plugin
export default {"pageWrapper":"Events_pageWrapper__gYW0n","pageHeader":"Events_pageHeader__ZXpct"};